import { render, staticRenderFns } from "./reqQuotelist.vue?vue&type=template&id=67d6392d&scoped=true&"
import script from "./reqQuotelist.vue?vue&type=script&lang=js&"
export * from "./reqQuotelist.vue?vue&type=script&lang=js&"
import style0 from "./reqQuotelist.vue?vue&type=style&index=0&id=67d6392d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d6392d",
  null
  
)

export default component.exports